import {
  SaleOrderStatusEnum,
  SupplierWarehouseProps,
  SupplyOrderItemProps,
  SupplyOrderProps,
} from '@/types'

export const getBuyerName = (supplyOrderItems: SupplyOrderItemProps[]) => {
  const buyers: string[] = []

  supplyOrderItems?.forEach((item) => {
    item.supplyChainLink?.forEach((link) => {
      if (
        link?.saleOrderItem?.saleOrder?.buyer?.companyName &&
        !buyers.includes(link.saleOrderItem?.saleOrder?.buyer?.companyName)
      ) {
        buyers.push(link.saleOrderItem?.saleOrder?.buyer?.companyName)
      }
    })
  })

  return buyers.join(', ') || '-'
}

export const addressLine = (address: SupplierWarehouseProps): string => {
  const baseAddress = `${address?.street}, ${address?.number}`
  const postalReference = `${address?.postalCode}, ${address?.neighborhood}`
  const location = `${address?.city}, ${address?.state}`

  if (address?.complement) {
    return `${baseAddress}, ${address?.complement}, ${postalReference} - ${location}`
  } else {
    return `${baseAddress}, ${postalReference} - ${location}`
  }
}

export const getDestinationAddress = (record: SupplyOrderProps) => {
  let destinationAddress: string = '-'

  for (const item of record?.items || []) {
    if (item?.supplyChainLink) {
      for (const link of item.supplyChainLink) {
        const address = link?.saleOrder?.shipments?.[0]?.destinationAddress
        if (address) {
          return address
        }
      }
    }
  }

  const supplierWarehouseItem = record?.items?.find(
    (item) => item?.supplierWarehouse,
  )
  if (supplierWarehouseItem?.supplierWarehouse) {
    destinationAddress = addressLine(
      supplierWarehouseItem.supplierWarehouse as SupplierWarehouseProps,
    )
  }

  return destinationAddress
}

export const getSaleOrders = (record: SupplyOrderProps) => {
  return record?.items?.reduce(
    (acc, item) => {
      item?.supplyChainLink?.forEach((link) => {
        const saleOrder = link?.saleOrderItem?.saleOrder
        if (saleOrder && !acc.find((so) => so?.uuid === saleOrder?.uuid)) {
          acc.push({
            uuid: saleOrder?.uuid || '',
            order: saleOrder?.reference || '',
            companyName: saleOrder?.buyer?.companyName || '',
            status: saleOrder?.status || '',
          })
        }
      })
      return acc
    },
    [] as {
      companyName: string
      uuid: string
      order: string
      status: keyof typeof SaleOrderStatusEnum
    }[],
  )
}
